<template>
  <div class="oss-container">
    <slot></slot>
  </div>
</template>

<script>
import qs from 'qs'
import { Toast } from 'vant'
import { isIOS, transferBytes } from '@/utils/tools'
import OSS from 'ali-oss'
const getRotate = () => {
  return import('@/utils/rotateImg.js')
}

let accessid = ''
let host = ''
let policyBase64 = ''
let signature = ''
let callbackbody = ''
let callbackVar = ''
let filename = ''
let key = ''
let expire = 0
let objectName = ''
let bucket = ''
let accessKeySecret = ''
let stsToken = ''
let objectKey = ''
let callbackUrl = ''
let callbackContentType = ''
export default {
  props: [
    'container',
    'browse_button',
    'actionFile',
    'originFile',
    'params',
    'args',
    'isClip'
  ],
  watch: {
    async actionFile (val) {
      if (val) {
        let {client, options} = await this.init()

        Toast.loading({
          duration: 0,
          forbidClick: true,
          message: ''
        })

        let { data } = await client.multipartUpload(objectKey, val, options).catch((err) => {
          this.$toast('上传失败，请重试')
        }).finally(() => {
          if (!this.isClip) {
            Toast.clear()
          }
        })

        if (data.status !== 'OK') {
          this.$toast('上传失败，请重试')
          return
        }
        
        // 上传裁剪封面图的时候，把原图也上传
        let oData = null
        if (this.isClip && this.originFile) {
          let { client : oClient, options: oOptions} = await this.init(true)
          let { data } = await oClient.multipartUpload(objectKey, this.originFile, oOptions).catch((err) => {
            this.$toast('上传原图失败，请重试')
          })
          if (data.status !== 'OK') {
            this.$toast('上传原图失败，请重试')
            return
          }
          oData = data
        }

        let picId = data.picId

        let requestArr = [this.$http(`/api/member/image/url`, { picId }, 'get')]
        // 无需获取封面图原始url
        oData && requestArr.push(this.$http(`/api/member/image/url`, { picId: oData.picId }, 'get'))
        
        Promise.all(requestArr).then(res => {
          let emitData = {}
          const res1 = res[0]
          const res2 = res[1]
          if (res1.code === '0000') {
            emitData = res1.data
          }
          if (res2 && res2.code === '0000') {
            emitData.originId = res2.data.picId
            emitData.originUrl = res2.data.url
          }
          this.$emit('uploadSucess', {
            ...emitData,
            args: this.args
          })
        }).finally(() => {
          Toast.clear()
        })
      }
    }
  },

  methods: {
    async init (isOrigin) {
      await this.set_upload_param(isOrigin)
      let obj = {
        region: 'oss-cn-hangzhou',
        //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
        accessKeyId: accessid,
        accessKeySecret: accessKeySecret,
        stsToken: stsToken,
        bucket: bucket
      }
      const client = new OSS(obj)

      const options = {
        partSize: 500 * 1024,
        meta: {
          year: 2020,
          people: ''
        },
        callback: {
          url: callbackUrl,
          body: callbackbody,
          contentType: callbackContentType,
          customValue: callbackVar
        }
      }
      return { client, options }
    },
    async set_upload_param (isOrigin) {
      await this.get_signature(isOrigin)
      objectName = key

      let newMultipartParams = {
        'key': objectName,
        'policy': policyBase64,
        'OSSAccessKeyId': accessid,
        'success_action_status': '200', // 让服务端返回200,不然，默认会返回204
        'callback': callbackbody,
        'signature': signature,
        ...callbackVar
      }
      return newMultipartParams
    },
    async sendRequest (isOrigin) {
      var xmlhttp = null
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest()
      } else if (window.ActiveXObject) {
        // eslint-disable-next-line no-undef
        xmlhttp = new ActiveXObject('Microsoft.XMLHTTP')
      }
      if (xmlhttp != null) {
        let params = ''
        if (isOrigin) {
          params = qs.stringify({ ...this.params, original: 1 } || {})
        } else {
          params = qs.stringify(this.params || {})
        }
        const res = await this.$http(`/api/member/image/upload/sts?${params}`, {}, 'get')
        return res.data
      } else {
        console.log('Your browser does not support XMLHTTP.')
      }
    },

    async get_signature (isOrigin) {
      // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下，3s 作为缓冲。
      let obj = await this.sendRequest(isOrigin)
      host = obj['host']
      policyBase64 = obj['policy']
      accessid = obj['accessKeyId']
      signature = obj['signature']
      expire = parseInt(obj['expire'])
      callbackbody = obj['callbackBody']
      callbackVar = obj['callbackVar']
      key = obj['key']
      bucket = obj['bucket']
      accessKeySecret = obj['accessKeySecret']
      stsToken = obj['stsToken']
      objectKey = obj['objectKey']
      callbackUrl = obj['callbackUrl']
      callbackContentType = obj['callbackContentType']
    }
  },
  mounted () {
    let _this = this
    this.$nextTick(e => {
      let container = document.getElementById(this.browse_button)
      if (!container) return
      container.style.cssText = 'position: relative;overflow: hidden;display:block;z-index: 5;'

      let input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('id', this.browse_button)
      input.setAttribute('accept', 'image/*')
      input.setAttribute('class', 'hideInputFile')

      input.addEventListener('change', (e) => {
        let target = e.target
        let file = target.files[0]
        this.$emit('fileChange', {
          file: file,
          args: this.args
        })
      }, false)
      container.appendChild(input)
    })
  }
}
</script>

<style lang="scss">
.hideInputFile {
  font-size: 12px;
  opacity: 0;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
}
</style>
